import { Component } from '@angular/core';
import { AccountsTableComponent } from '../../components/accounts-table/accounts-table.component';

@Component({
  selector: 'app-accounts-page',
  imports: [AccountsTableComponent],
  templateUrl: './accounts-page.component.html',
  styleUrl: './accounts-page.component.css'
})
export class AccountsPageComponent {}
